import { render, staticRenderFns } from "./OpportunityView.vue?vue&type=template&id=12df3115&scoped=true&"
import script from "./OpportunityView.vue?vue&type=script&lang=js&"
export * from "./OpportunityView.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityView.vue?vue&type=style&index=0&id=12df3115&prod&scoped=true&lang=css&"
import style1 from "./OpportunityView.vue?vue&type=style&index=1&id=12df3115&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12df3115",
  null
  
)

export default component.exports